import React from 'react';
import { AuthPage } from '@refinedev/antd';

export const ForgotPassword: React.FC = () => {
  return <AuthPage type="forgotPassword" />;
};
